import React from "react";

import SmartImage from "../../../components/SmartImage";

const MAX_AVATARS = 3;

const NearbyToggle = ({ count, suppliers, open, loading, alwaysShow, onToggle }) => {
  if (loading) {
    return (
      <span className="home-nearby home-nearby-loading" aria-hidden="true">
        <span className="home-nearby-pulse" />
        <span className="home-nearby-text">
          <span className="home-nearby-title">Finding suppliers…</span>
          <span className="home-nearby-sub">Searching your area</span>
        </span>
      </span>
    );
  }

  if (!count && !alwaysShow) return null;

  const avatars = suppliers.slice(0, MAX_AVATARS);

  return (
    <button
      type="button"
      className={`home-nearby${open ? " is-open" : ""}`}
      onClick={onToggle}
      aria-expanded={open}
      aria-controls="home-supplier-panel"
    >
      {avatars.length ? (
        <span className="home-nearby-avatars" aria-hidden="true">
          {avatars.map((supplier) => (
            <span key={supplier.id} className="home-nearby-avatar">
              {supplier.logoUrl ? (
                <SmartImage src={supplier.logoUrl} alt="" width="100%" height="100%" />
              ) : (
                supplier.name.charAt(0)
              )}
            </span>
          ))}
        </span>
      ) : (
        <span className="home-nearby-pulse" aria-hidden="true" />
      )}

      <span className="home-nearby-text">
        <span className="home-nearby-title">
          {count
            ? `${count} ${count === 1 ? "Supplier" : "Suppliers"} nearby`
            : "Supplier list"}
        </span>
        <span className="home-nearby-sub">
          {open ? "Hide the list" : "Show the list"}
        </span>
      </span>

      <svg className="home-nearby-chevron" viewBox="0 0 20 20" aria-hidden="true">
        <path d="m5 12 5-5 5 5" />
      </svg>
    </button>
  );
};

export default React.memo(NearbyToggle);
